import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import LocationServices from '../../services/LocationServices';
function AddLocation() {
const navigate = useNavigate();
  
  const [formValues, setFormValues] = useState({
    cityName: '',
    pincode: '',
  
  });


  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const formData = new FormData();
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    await LocationServices.createLocation(formValues);
    alert('Location created successfully');
    navigate('/location');
    
  } catch (error) {
    console.error('Failed to create Location', error);
    alert('Failed to create Location');
  }
};

  return (
    <>
    <div className="right_col" role="main">
        <div className="title-box">
          <h2>Location Manager</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/location"> Location List</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="input-field">
                  <label>City Name<span className='red'>*</span></label>
                  <input type="text" name="cityName" value={formValues.cityName} 
                        onChange={handleInputChange} defaultValue="Product scanning" className="form-control" placeholder='City Name'  />
                </div>
                <div className="input-field">
                  <label>Pincode<span className='red'>*</span></label>
                  <input type="number" name="pincode" value={formValues.pincode} 
                        onChange={handleInputChange} maxLength={6} defaultValue="Product scanning" className="form-control" placeholder='Pincode' />
                </div>
               
                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddLocation